import * as o from "react";
import e from "../lib/IconBase.es.js";
import t from "../defs/Bookmark.es.js";
const r = o.forwardRef((a, m) => /* @__PURE__ */ o.createElement(e, { ref: m, ...a, weights: t }));
r.displayName = "BookmarkIcon";
const k = r;
export {
  k as Bookmark,
  r as BookmarkIcon
};
